






































import Vue from 'vue'
import { mask } from 'vue-the-mask'

import validationRules from '@/utils/validation'

import { ApiService } from '@/services'

export default Vue.extend({
  name: 'GiveAwayNotificationModal',

  directives: {
    mask,
  },

  props: {
    proofId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      firstName: '',
      email: '',
      phone: '',
      nameRules: validationRules.nameRules,
      phoneRules: validationRules.phoneRules,
      emailRules: validationRules.emailRules,
    }
  },

  methods: {
    enterGiveAway() {
      if (!this.$refs.giveAwayNotificationForm.validate()) return

      ApiService.put(`reverseFlow/proof/updateEntry/${this.proofId}`, {
        first_name: this.firstName,
        email: this.email,
        phone: this.phone,
      })
        .then((response) => {
          if (response.data.error) {
            throw Error(response.data.error)
          }

          this.$toast.success(`Great! You'll be notified if you win`)

          this.$router.push({ path: `/swayOffer/entered/${this.proofId}` })
        })
        .catch((error) => {
          this.$toast.error(error)
        })
    },
  },
})
